import { styled, css } from "styled-components";

export const Busy = styled.div<{ $busy?: boolean }>`
  transition: opacity 0.12s ease-in-out;

  ${(props) =>
    props.$busy &&
    css`
      cursor: wait;
      opacity: 0.25;
    `};
`;
